var parser = require('./lib/parser');
var compiler = require('./lib/compiler');

module.exports = {
  parse: function(input) {
    var nodes = parser.parse(input.toString());
    return compiler.compile(nodes);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/toml/index.js
// module id = 1057
// module chunks = 0